<template>
  <JobCard :jobInfo="jobInfo">
    <div slot="header" @click="cancelCollect(jobInfo.positionId)">
      <span class="collect-action fonticon">&#xe623;</span>
      <span class="collect-action">取消收藏</span>
    </div>
    <span slot="status">{{ jobInfo.delivery ? "已投递" : "未投递" }}</span>
  </JobCard>
</template>

<script>
import JobCard from "./JobCard.vue";
export default {
  props: {
    jobInfo: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    JobCard
  },
  methods: {
    async cancelCollect(positionId) {
      const res = await this.$axios({
        url: `/portal/position/favorites/${positionId}`,
        method: "DELETE"
      });
      if (res.code === 200) {
        this.$emit("updateDate"); // 通知List组件更新数据
        this.$message({ type: "success", message: "取消收藏成功!" });
      } else {
        this.$message({ type: "error", message: res.message });
      }
    }
  }
};
</script>

<style lang="scss">
.collect-action {
  margin-left: 3px;
  color: #049cfd;
  cursor: pointer;
  font-size: 14px;
}
</style>
